/**
 *
 * WORDPACKS Constant
 *
 * This is a list of all wordpacks that we can expect to find. If a new wordpack
 * is added, an entry must be added here containing the pack name and the path
 * (from /public) to get to it. The name given here is the display name, and
 * the path should contain the location of the file to index as a wordPack.
 */

export const WORDPACKS = {
  Animals: "/animals.txt",
  Birds: "/birds.txt",
  Bacteria: "/bacteria.txt",
};
